<div *ngIf="!!participant">
	<h1>{{ participant.id }}</h1>
	<nz-divider></nz-divider>
</div>
<div *ngIf="!participant" class="gutter">
	<nz-alert
			nzType="warning"
			nzCloseable
			nzMessage="{{ 'message.warning.participant.noneLoaded.title' | translate }}"
			nzDescription="{{ 'message.warning.participant.noneLoaded.description' | translate }}"
	>
	</nz-alert>
</div>
<workflow-projektsidebar></workflow-projektsidebar>
<div nz-row [nzGutter]="[16, 6]" *ngIf="workflow != null && workflow.items != null">
	<div *ngFor="let category of categories, let i = index" nz-col [nzSpan]="24" [nzXXl]="6" [nzXl]="8" [nzLg]="12" [nzMd]="24">
		<nz-card class="card-tile-category" nzSize="small" nzTitle="{{ i+1 }}. {{ category.name }}">

			<nz-card class="card-tile-item" *ngFor="let workflowItem of category.items" nzTitle="{{ workflowItem.name }}" nzSize="small"
			[nzExtra]="popOverCard">
				<nz-card-meta nzDescription="{{ workflowItem.description }}"></nz-card-meta>
				<perfect-scrollbar scrollIndicators="true">
					<div *ngIf="workflowItem.type === 'Questionnaire'" class="scrollBar">
						<div *ngIf="getWorkflowItemAsQuestionnaire(workflowItem).groups.length > 1">
							<ol>
								<li *ngFor="let page of getWorkflowItemAsQuestionnaire(workflowItem).groups, let j = index">
									<a [routerLink]="getRecommendedLink(workflowItem,j)" routerLinkActive="active">{{page.title}}</a>
								</li>
							</ol>
						</div>
						<div *ngIf="getWorkflowItemAsQuestionnaire(workflowItem).groups.length === 1">
							<a [routerLink]="getRecommendedLink(workflowItem,0)" routerLinkActive="active">
								{{getWorkflowItemAsQuestionnaire(workflowItem).groups[0].title}}
							</a>
						</div>
					</div>
				</perfect-scrollbar>

				<!--In ngFor fpr den Context-->
				<ng-template #popOverCard>
					<button nz-button routerLink="details/{{workflowItem.id}}">Details</button>
					<button nz-button nz-popover nzPopoverTitle="{{ 'actions.openAs' | translate }}..." nzPopoverTrigger="click"
							[nzPopoverContent]="popOverContent" *ngIf="workflowItem.type === 'Questionnaire'"><i-feather name="menu"></i-feather></button>
				</ng-template>

				<ng-template #popOverContent>
					<b *ngIf="hasAllDevices(workflowItem)">
						<a nz-row routerLink="wizard/{{workflowItem.id}}/0">{{ 'workflow.distractionfreeWizard' | translate }}</a>
					</b>
					<a *ngIf="!hasAllDevices(workflowItem)" nz-row routerLink="wizard/{{workflowItem.id}}/0">
						{{ 'workflow.distractionfreeWizard' | translate }}</a>

					<b *ngIf="!hasAllDevices(workflowItem)">
						<a nz-row routerLink="compact/{{workflowItem.id}}">{{ 'workflow.compactView' | translate }}</a>
					</b>
					<a *ngIf="hasAllDevices(workflowItem)" nz-row routerLink="compact/{{workflowItem.id}}">{{ 'workflow.compactView' | translate }}</a>
				</ng-template>
			</nz-card>

		</nz-card>

	</div>
</div>
